var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77508 9.87501C8.30227 9.87501 10.7791 6.12337 10.7791 2.87095C10.7791 2.76548 10.7768 2.65766 10.7721 2.5522C11.2539 2.20375 11.6697 1.77214 12 1.27766C11.5513 1.47732 11.0748 1.60771 10.587 1.66438C11.1006 1.35647 11.4853 0.872751 11.6695 0.302899C11.1863 0.589294 10.6578 0.791321 10.1067 0.900321C9.73542 0.505796 9.24449 0.244573 8.70984 0.157041C8.17519 0.0695081 7.6266 0.16054 7.14887 0.416063C6.67115 0.671587 6.2909 1.07737 6.06692 1.57067C5.84295 2.06397 5.78771 2.61732 5.90977 3.14516C4.93125 3.09606 3.97397 2.84187 3.09999 2.39906C2.22601 1.95626 1.45485 1.33473 0.836484 0.574774C0.5222 1.11664 0.426028 1.75784 0.567515 2.36806C0.709002 2.97828 1.07753 3.51174 1.5982 3.86001C1.20731 3.8476 0.824988 3.74236 0.482813 3.55298V3.58345C0.482462 4.15209 0.679049 4.70331 1.03915 5.1434C1.39926 5.58349 1.90066 5.8853 2.45812 5.99751C2.09603 6.09658 1.71599 6.11101 1.34742 6.0397C1.50473 6.52873 1.81079 6.95646 2.22289 7.26318C2.63498 7.5699 3.13256 7.74031 3.64617 7.75063C2.77421 8.43557 1.69709 8.80708 0.588281 8.80532C0.391644 8.80502 0.1952 8.79297 0 8.76923C1.12643 9.49189 2.43677 9.87571 3.77508 9.87501Z",
    fill: "url(#paint0_linear_385_15215)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_15215",
    x1: 6,
    y1: 0.124649,
    x2: 6,
    y2: 9.87501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.609034d9ca2dcc20bae8987667b18092.svg";
export { ForwardRef as ReactComponent };